import { render } from "./company.vue?vue&type=template&id=d7dec4de&scoped=true"
import script from "./company.vue?vue&type=script&lang=ts"
export * from "./company.vue?vue&type=script&lang=ts"

import "./company.vue?vue&type=style&index=0&id=d7dec4de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d7dec4de"

export default script